import { useState } from 'react';

export default function Portfolio() {
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  const projects = [
    {
      id: 1,
      client: 'Anadolu Bahçe Ürünleri',
      category: 'Gıda Etiketleri',
      image: 'https://public.readdy.ai/ai/img_res/b4212f5fb4ac6bf78b1f176752230a90.jpg',
      height: 'md:row-span-2'
    },
    {
      id: 2,
      client: 'Nokta Cilt Bakım',
      category: 'Kozmetik Etiketleri',
      image: 'https://readdy.ai/api/search-image?query=skincare%20product%20line%20flatlay%20with%20amber%20glass%20dropper%20bottles%20and%20white%20pump%20dispensers%20showing%20clean%20sans%20serif%20minimalist%20labels%20on%20a%20terrazzo%20surface%20natural%20ingredients%20nearby%20botanical%20brand%20photography&width=600&height=400&seq=port-cosmetic-v2-402&orientation=landscape',
      height: 'md:row-span-1'
    },
    {
      id: 3,
      client: 'Medikal Çözüm A.Ş.',
      category: 'İlaç Etiketleri',
      image: 'https://readdy.ai/api/search-image?query=hospital%20pharmacy%20organized%20medicine%20shelf%20with%20prescription%20bottles%20featuring%20crisp%20white%20labels%20with%20patient%20dosage%20info%20and%20barcodes%20sterile%20clinical%20environment%20overhead%20fluorescent%20lighting%20healthcare%20packaging%20display&width=600&height=400&seq=port-pharma-v2-403&orientation=landscape',
      height: 'md:row-span-1'
    },
    {
      id: 4,
      client: 'Sistem Makine San.',
      category: 'Endüstriyel Etiketler',
      image: 'https://readdy.ai/api/search-image?query=CNC%20machine%20control%20panel%20closeup%20showing%20durable%20printed%20labels%20with%20voltage%20ratings%20safety%20symbols%20and%20serial%20numbers%20attached%20to%20metal%20surface%20in%20manufacturing%20plant%20dramatic%20angle%20workshop%20lighting%20industrial%20detail&width=600&height=600&seq=port-industrial-v2-404&orientation=squarish',
      height: 'md:row-span-2'
    },
    {
      id: 5,
      client: 'Berrak Doğal Gıda',
      category: 'Gıda Etiketleri',
      image: 'https://readdy.ai/api/search-image?query=eco%20organic%20honey%20and%20natural%20spread%20jars%20on%20a%20kitchen%20counter%20with%20earthy%20kraft%20labels%20tied%20with%20jute%20twine%20showing%20handwritten%20style%20font%20and%20green%20leaf%20motif%20morning%20light%20streaming%20in%20through%20window%20cozy%20natural%20kitchen&width=600&height=400&seq=port-organic-v2-405&orientation=landscape',
      height: 'md:row-span-1'
    },
    {
      id: 6,
      client: 'Luxe Parfüm Atölyesi',
      category: 'Kozmetik Etiketleri',
      image: 'https://readdy.ai/api/search-image?query=luxury%20perfume%20bottles%20arranged%20on%20a%20black%20lacquered%20tray%20with%20gold%20foil%20embossed%20labels%20showing%20fragrance%20name%20in%20elegant%20serif%20typography%20dark%20moody%20studio%20lighting%20with%20light%20reflections%20on%20glass%20high%20end%20fragrance%20brand%20photography&width=600&height=400&seq=port-luxury-v2-406&orientation=landscape',
      height: 'md:row-span-1'
    }
  ];

  return (
    <section id="portfolio" className="py-24 bg-gradient-to-br from-slate-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Başlık */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6 mb-16">
          <div>
            <h2 className="text-4xl font-normal text-[#1A2332] leading-tight">
              Başarılı
            </h2>
            <h2 className="text-4xl font-bold italic text-[#FF6B35] leading-tight mt-1">
              Projelerimiz
            </h2>
          </div>
          <a 
            href="#contact"
            className="inline-flex items-center px-6 py-3 text-sm font-semibold text-[#FF6B35] border-2 border-[#FF6B35] rounded-full hover:bg-[#FF6B35] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Tüm Projeleri Gör
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
        
        {/* Galeri Grid */}
        <div className="grid md:grid-cols-3 gap-6 auto-rows-[300px]">
          {projects.map((project) => (
            <div 
              key={project.id}
              className={`group relative rounded-3xl overflow-hidden cursor-pointer ${project.height}`}
              onMouseEnter={() => setHoveredId(project.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              {/* Görsel */}
              <div className="w-full h-full">
                <img 
                  src={project.image}
                  alt={`${project.client} - ${project.category} profesyonel etiket baskı projesi`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  loading="lazy"
                  decoding="async"
                  width={project.height === 'md:row-span-2' ? '600' : '600'}
                  height={project.height === 'md:row-span-2' ? '600' : '400'}
                />
              </div>
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-xl font-semibold text-white mb-2">
                    {project.client}
                  </h3>
                  <p className="text-sm text-white/80 mb-4">
                    {project.category}
                  </p>
                  
                  {hoveredId === project.id && (
                    <div className="flex items-center text-white font-medium animate-fade-in">
                      Detayları Gör
                      <i className="ri-arrow-right-line ml-2"></i>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Alt Bilgi */}
        <div className="mt-16 text-center">
          <p className="text-sm text-gray-600 mb-6">
            Gıdadan farmasötiğe, kozmetikten sanayiye — 20 yıldır her sektörde özgün etiket projeleri üretiyoruz
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <span className="px-4 py-2 bg-white rounded-full text-sm text-gray-700 shadow-sm">
              Gıda Sektörü
            </span>
            <span className="px-4 py-2 bg-white rounded-full text-sm text-gray-700 shadow-sm">
              Kozmetik
            </span>
            <span className="px-4 py-2 bg-white rounded-full text-sm text-gray-700 shadow-sm">
              Farmasötik
            </span>
            <span className="px-4 py-2 bg-white rounded-full text-sm text-gray-700 shadow-sm">
              Endüstriyel
            </span>
            <span className="px-4 py-2 bg-white rounded-full text-sm text-gray-700 shadow-sm">
              Tekstil
            </span>
          </div>
        </div>
      </div>
      
      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.3s ease-out;
        }
      `}</style>
    </section>
  );
}